import Layout from "../../components/Layout"
import OrderList from "../../components/Order/OrderList";

export default function StoreOrders() {
    return (
        <Layout>
            <OrderList asStore={true}/>
        </Layout>
    )
}